export enum PlatformKey {
  TBM = "tbm-fid'",
  AVANTAG = 'avantag',
  IRIGO = 'irigo',
  STAN = 'stan',
  ECOBONUS = 'ecobonus',
  BKLUB = 'b-klub',
  ASTUCE = 'astuce',
  STAR = 'star',
  IZILO = 'izilo',
  CLUBEO = 'clubeo',
  TCL = 'fidelite-tcl',
  TUL = 'tul-privilege',
  MOBICLUB = "citur'avantage",
  SISMO = 'oise-mobilite',
  STAS = 'stas',
  ECOMOTIVE = 'ecomotive',
  SAMOBILITE = 'samobilite',
  TWISTO = 'twisto',
  LEKLUB = 'le-klub',
  TAO = 'tao',
}

export enum ServiceKey {
  MODALIS = 'modalis',
  TBM = 'tbm',
  IRIGO_ATOUT = 'irigo-atout',
  IRIGO_MTICKET = 'irigo-mticket',
  AVANTAG = 'avantag',
  WEFLO = 'weflo',
  BIBUS_MTICKET = 'm-ticket-bibus',
  KORRIGO_BREST = 'korrigo-brest',
  MY_ASTUCE = 'maas-rouen--cityway',
  CLUB_ASTUCE = 'club-astuce',
  TBM_MTICKET = 'tbm-mticket',
  IZILO = 'izilo',
  TCL = 'tcl',
  OURA = 'oura',
  TUL = 'tul-privilege',
  OISE = 'oise-mobilite',
  SAMOBILITE = 'samobilite',
  TWISTO = 'twisto-card',
  TWISTO_MTICKET = 'twisto-mticket',
  TAO = 'tao',
}

export enum PageName {
  ERROR = 'error',
  HOME = 'home',
}

export enum Errors {
  SSO_LOGIN_REQUIRED = 'login_required',
}

// When adding a new service, please add "cust_tooltips_[serviceKey].webp" to the assets/tooltips folder and add the service key to the SERVICE_TOOLTIP_IMAGES constant below.
export const SERVICE_TOOLTIP_IMAGES: Partial<Record<ServiceKey, any>> = {
  [ServiceKey.BIBUS_MTICKET]: {
    mainDesc: ' ',
    imageSrc: require('@/assets/tooltips/cust_tooltips_bibus.webp'),
    optionalDesc: ' ',
  },
  [ServiceKey.TWISTO_MTICKET]: {
    mainDesc: ' ',
    imageSrc: require('@/assets/tooltips/cust_tooltips_twisto_mticket.webp'),
    optionalDesc: ' ',
  },
  [ServiceKey.TWISTO]: {
    mainDesc: ' ',
    imageSrc: require('@/assets/tooltips/cust_tooltips_twisto_card.webp'),
    optionalDesc: ' ',
  },
};
